import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../components/welcome";
import NotFound from "../utils/NotFound";
// import CustomerSelectOrder from "../components/welcome/CustomerSelectOrder";
import Poster from "../components/welcome/Poster";
import CustomerOrdering from "../components/welcome/CustomerOrdering";

const LoginRoute = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route hidden path="/" element={<LoginPage />} />
        <Route
          hidden
          path="/:merchant_id/:merchant_uid"
          element={<CustomerOrdering />}
        />
        <Route hidden path="/poster-1" element={<Poster />} />
        {/* <Route
          hidden
          path="/test-ordering-design/:merchant_id/:merchant_uid"
          element={<CustomerOrdering />}
        /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
};

export default LoginRoute;
